import ScheduleType from "../../shared/enum/ScheduleTypeEnum";
import OptionInterface from "../../shared/interfaces/OptionInterface";

export const SCHEDULE_TYPES: OptionInterface<ScheduleType>[] = [
  {
    label: "Viaje instantaneo",
    value: ScheduleType.INSTANT,
  },
  {
    label: "Multiples viajes",
    value: ScheduleType.MULTIPLE,
  },
  {
    label: "Viaje redondo",
    value: ScheduleType.ROUND,
  },
  {
    label: "Agendar viaje",
    value: ScheduleType.SCHEDULED,
  }
]